import connection from './connection.js'


const create = async function (params, callback) {
  const url = '/admin/store/add'
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const edit = async function (params, id, callback) {
  const url = `/admin/store/update/${id}`
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const list = async function (page,per_page,q,callback) {
  if(q && q.store_name){
    const url = '/admin/store/list'
    let {
      error,
      data
    } = await connection.query(url,{
      page: page,
      per_page: per_page,
      q: JSON.stringify(q)
    })
    if (callback) callback(error, data)
  }else{
    const url = '/admin/store/list'
    let {
      error,
      data
    } = await connection.query(url,{
      page: page,
      per_page: per_page
    })
    if (callback) callback(error, data)
  }

}

const fetchDetail = async function (pa,callback) {
  const url = `/admin/store/detail/${pa.id}`
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

const changeSwitchOfCustomPush = async function (id,params,callback) {
  const url = `/admin/store/status/customs/${id}`
  let {
    error,
    data
  } = await connection.update(url,params)
  if (callback) callback(error, data)
}

const changeSwitchOfRecommend = async function (id,params,callback) {
  const url = `/admin/store/status/recommend/${id}`
  let {
    error,
    data
  } = await connection.update(url,params)
  if (callback) callback(error, data)
}

const deleteStore = async function (id,callback) {
  const url = `/admin/store/delete/${id}`
  let {
    error,
    data
  } = await connection.update(url)
  if (callback) callback(error, data)
}

const editPushConfig = async function (params,id,callback) {
  const url = `/admin/store/import/config/update/${id}`
  let {
    error,
    data
  } = await connection.update(url,params)
  if (callback) callback(error, data)
}

const fetchConfigDetail = async function (pa,callback) {
  const url = `/admin/store/import/config/detail/${pa.id}`
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}




export default {

  create: create,
  list: list,
changeSwitchOfCustomPush:changeSwitchOfCustomPush
,
changeSwitchOfRecommend: changeSwitchOfRecommend,
deleteStore: deleteStore,
fetchDetail: fetchDetail,
edit: edit,
editPushConfig: editPushConfig,
fetchConfigDetail: fetchConfigDetail
}
